export default __webpack_public_path__ + "static/media/c_img.8ddafe4a.svg";